module.exports = __webpack_public_path__ + "img/wallet.bc78f942.svg";